import { isAmendableExtraLine } from '#/lib/isAmendableExtraLine';
import { UpdateBookingValues } from '@jucy-ui/common';
import { ValidateUpdateResponse } from '@jucy/rentals-api-client/rentals-api-v3/models';
import { HirerDetails } from '@jucy/rentals-api-client/rentals-api-v3/models/HirerDetails';

export const mapUpdateRequest = (data: ValidateUpdateResponse): UpdateBookingValues => {
    if (!data.original) {
        throw Error('Original booking not found');
    }
    if (!data.updates) {
        throw Error('Updates not found');
    }
    const hirerDetails = (data.original?.hirerDetails || {}) as Partial<HirerDetails>;

    return {
        driverAge: `${data.original.driverAge}`,
        dropOffDate: data.updates.dropOffDate,
        dropOffBranch: data.updates.dropOffLocation,
        dropOffTime: data.updates.dropOffDate,
        fleetType: data.updates.fleetCategory.fleetTypeCode,
        fleetCategory: data.updates.fleetCategory.categoryCode,
        pickUpDate: data.updates.pickUpDate,
        pickUpBranch: data.updates.pickUpLocation,
        pickUpTime: data.updates.pickUpDate,
        promoCode: data.updates.fleetCategory.campaignCode,
        // deal: data.updates.deal,
        reservationReference: data.original?.reservationReference,
        insurance: data.updates?.lines?.find((line) => line.category === 'InsuranceFee' && !line.isExcluded)?.productCode || '',
        secondaryProducts: (data.updates?.lines || []).filter(isAmendableExtraLine).reduce(
            (secondaryProducts, line) => ({
                ...secondaryProducts,
                [line.productCode]: (secondaryProducts[line.productCode] || 0) + (line.qty || 1),
            }),
            {} as Record<string, number>
        ),
        hirerDetails: {
            firstName: hirerDetails.firstName,
            lastName: hirerDetails.lastName,
            mobileNumber: hirerDetails.mobileNumber,
            email: hirerDetails.email,
            driversLicenceCountry: hirerDetails.driversLicence?.country,
            acceptedTerms: true,
            mailingList: hirerDetails.mailingList,
        },
    };
};
